import React from 'react'
import { toast } from 'react-toastify'
import { LoadingButton } from '@mui/lab'
import { Dialog, DialogContent, DialogTitle } from '@mui/material'
import { useMutation } from '@tanstack/react-query'
import EsimAPI from 'api/faber/EsimAPI'
import { RoundedButton } from 'common/Button/Button'
import NormalText from 'common/Typography/NormalText'
import OrbitSession from 'hooks/useCookies'

function ReprovisionEsimDialog({
  isDialogOpen,
  handleClose,
  userId
}: {
  isDialogOpen: boolean
  handleClose: () => void
  userId: string
}) {
  const [isBtnLoading, setIsBtnLoading] = React.useState(false)
  const { mutate: reprovisionEsim } = useMutation({
    mutationFn: EsimAPI.reprovisionEsim
  })

  const handleReprovisionEsim = () => {
    setIsBtnLoading(true)
    reprovisionEsim(
      {
        userId: userId,
        faberToken: OrbitSession.get('faberToken')
      },
      {
        onSuccess: () => {
          handleClose()
          toast.success(
            'eSIM reprovisioned successfully.Please refresh page to see updated status'
          )
        },
        onError: () => {
          toast.error('Failed to reprovision eSIM.Please escalate to the devs')
        },
        onSettled: () => {
          setIsBtnLoading(false)
        }
      }
    )
  }

  return (
    <Dialog
      onClose={handleClose}
      open={isDialogOpen}
      aria-labelledby='reprovision-esim-dialog'
      fullWidth
      maxWidth='sm'
    >
      <DialogTitle>Reprovision esim</DialogTitle>
      <DialogContent>
        <NormalText>
          This is for customer who has missing eSIM QR code (i.e. if the eSIM
          status is N/A)
        </NormalText>
        <NormalText>
          After replacing the eSIM, please use the resend esim email function to
          resend esim qr code to the customer
        </NormalText>
        <NormalText>
          Please terminate the old packs (if not terminated automatically) after
          reprovisioning the eSIM. <br />
          Note: Old packs can be determined by looking at the purchased date
          information
        </NormalText>
        <RoundedButton variant='outlined' onClick={handleClose}>
          Cancel
        </RoundedButton>
        <LoadingButton
          variant='filled'
          onClick={handleReprovisionEsim}
          loading={isBtnLoading}
          loadingIndicator='Loading...'
        >
          Send
        </LoadingButton>
      </DialogContent>
    </Dialog>
  )
}

export default ReprovisionEsimDialog
